export default __webpack_public_path__ + "static/media/Icons_Help Icon.498e0274.svg";